/* Copy-link control for the calculator suite (IS #359).

   The calculators already write their inputs into the query string as you type
   (history.replaceState), so window.location.href is a permalink to the current
   result. This just makes that copyable, because the URL state was invisible to
   users and therefore never produced a shared link.

   Deliberately dependency-free and defensive: navigator.clipboard is unavailable
   on http:// and in some in-app browsers, so there is a execCommand fallback and
   a last-resort "select the URL yourself" state rather than a dead button.
*/
(function () {
  'use strict';

  var RESET_MS = 2400;

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    // Keep it off-screen but focusable; readOnly stops the mobile keyboard.
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    var ok = false;
    try {
      ta.select();
      ok = document.execCommand('copy');
    } catch (err) {
      ok = false;
    }
    document.body.removeChild(ta);
    return ok;
  }

  function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(function () {
        return true;
      }).catch(function () {
        return fallbackCopy(text);
      });
    }
    return Promise.resolve(fallbackCopy(text));
  }

  function announce(btn, ok) {
    var label = btn.querySelector('[data-calc-share-label]');
    var status = btn.parentNode.querySelector('[data-calc-share-status]');
    var original = btn.getAttribute('data-original-label');
    if (!original && label) {
      original = label.textContent;
      btn.setAttribute('data-original-label', original);
    }
    if (label) label.textContent = ok ? 'Link copied' : 'Press Ctrl+C to copy';
    if (status) status.textContent = ok ? '' : window.location.href;
    btn.classList.toggle('is-calc__share-btn--copied', ok);

    window.setTimeout(function () {
      if (label && original) label.textContent = original;
      if (status) status.textContent = '';
      btn.classList.remove('is-calc__share-btn--copied');
    }, RESET_MS);
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-calc-share]') : null;
    if (!btn) return;
    evt.preventDefault();
    Promise.resolve(copy(window.location.href)).then(function (ok) {
      announce(btn, ok);
    });
  });
})();
